import { FilterBarDateTimeMatcherOptions, FieldMatcher } from '@cdw-ae/filter-bar-interfaces';

type DateTimeMatcherOptionsKeys = keyof typeof FilterBarDateTimeMatcherOptions;
type MatcherValueType = { option: DateTimeMatcherOptionsKeys; value: string | { start: string; end: string } };

export const DateTimeMatcher: FieldMatcher = {
  name: 'dateTime',
  displayName: 'Match by DateTime',
  hasEditor: true,
  options: {
    toolTipFormatter: (value: string): string => {
      const optionValue: MatcherValueType = JSON.parse(value) as MatcherValueType;

      if (optionValue.option === 'beforeDateTime' || optionValue.option === 'sinceDateTime') {
        const formatDate = Intl.DateTimeFormat('en-US', { dateStyle: 'medium', timeStyle: 'medium' }).format(
          new Date(optionValue.value as string)
        );
        return `${FilterBarDateTimeMatcherOptions[optionValue.option]} ${formatDate}`;
      }

      if (optionValue.option === 'betweenDateTime') {
        const range = optionValue.value as { start: string; end: string };
        const startDate = Intl.DateTimeFormat('en-US', { dateStyle: 'medium', timeStyle: 'medium' }).format(
          new Date(range.start)
        );
        const endDate = Intl.DateTimeFormat('en-US', { dateStyle: 'medium', timeStyle: 'medium' }).format(
          new Date(range.end)
        );
        return `${FilterBarDateTimeMatcherOptions[optionValue.option]} ${startDate} and ${endDate}`;
      }

      return '';
    },

    chipFormatter: (value: string): string => {
      const optionValue: MatcherValueType = JSON.parse(value) as MatcherValueType;
      if (optionValue.option === 'beforeDateTime' || optionValue.option === 'sinceDateTime') {
        const formatDate = Intl.DateTimeFormat('en-US', { dateStyle: 'short', timeStyle: 'short' }).format(
          new Date(optionValue.value as string)
        );
        return `: ${FilterBarDateTimeMatcherOptions[optionValue.option]} ${formatDate}`;
      }

      if (optionValue.option === 'betweenDateTime') {
        const range = optionValue.value as { start: string; end: string };
        const startDate = Intl.DateTimeFormat('en-US', { dateStyle: 'short' }).format(new Date(range.start));
        const endDate = Intl.DateTimeFormat('en-US', { dateStyle: 'short' }).format(new Date(range.end));
        return `: ${FilterBarDateTimeMatcherOptions[optionValue.option]} ${startDate} and ${endDate}`;
      }

      return FilterBarDateTimeMatcherOptions[optionValue.option].toLocaleLowerCase();
    },
  },
  editorOptions: {
    selectionOptions: [],
  },
};